export class StorageHandler {
  storage: Storage
  subStorage: Storage

  constructor() {
    try {
      this.storage = window.localStorage
    } catch (e) {
      this.storage = window.sessionStorage
    }
    this.subStorage = window.sessionStorage
  }

  set(key: string, value: string) {
    try {
      this.storage.setItem(key, value)
    } catch (e) {
      this.subStorage.setItem(key, value)
    }
  }

  get(key: string): string {
    return this.storage.getItem(key) || this.subStorage.getItem(key)
  }
}

export class StorageKeys {
  static get categoryIdKey() {
    return "lcat"
  }

  static get cityIdKey() {
    return "lcty"
  }

  static get prefectureIdKey() {
    return "lpref"
  }
}
